import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Store } from "@ngrx/store";
import { IAppState } from "@edp-store/state/app.state";
import { map } from "rxjs/operators";
import { IEnergyComparison, IHouseEnergyComparisonPayload } from "@edp-models/energy-comparison.model";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class EnergyComparisonService {
  
    constructor(private http: HttpClient, private apiService: ApiService, private store: Store<IAppState>) {}

    public getEnergyComparison({CPE, date}: IHouseEnergyComparisonPayload): Observable<IEnergyComparison> {
        return this.apiService.callServicePostToCollectionCatalog("house.energy.comparison", { CPE, date })
        .pipe(map((response: any) => response[0]));
    }

}
